export const UNCAUGHT_JS_ERROR = 'UNCAUGHT_JS_ERROR';

//Render
export const RENDER_FAILURE = 'RENDER_FAILURE';
export const RENDER_SUCCESS = 'RENDER_SUCCESS';

//definition fetch
export const DEFINITION_NOT_FOUND = 'DEFINITION_NOT_FOUND';
export const INVALID_FORM_GUID = 'INVALID_FORM_GUID';
export const INVALID_PORTAL_ID = 'INVALID_PORTAL_ID';
export const INVALID_LANG = 'INVALID_LANG';
export const SUBMISSION_PERIOD_ENDED = 'SUBMISSION_PERIOD_ENDED';
export const RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED';
export const NON_EMBEDDABLE_FORM = 'NON_EMBEDDABLE_FORM';
export const IP_ADDRESS_IS_PROBABLY_A_BOT = 'IP_ADDRESS_IS_PROBABLY_A_BOT';
export const FORBIDDEN = 'FORBIDDEN';
export const DEFINITION_FAILURE = 'DEFINITION_FAILURE';
export const FALLBACK_DEFINITION_FAILURE = 'FALLBACK_DEFINITION_FAILURE';
export const DEFINITION_SUCCESS = 'DEFINITION_SUCCESS';
export const FALLBACK_DEFINITION_SUCCESS = 'FALLBACK_DEFINITION_SUCCESS';

//Submission
export const SUBMISSION_SUCCESS = 'SUBMISSION_SUCCESS';
export const SUBMISSION_FAILURE = 'SUBMISSION_FAILURE';
export const RECAPTCHA_VALIDATION_ERROR = 'RECAPTCHA_VALIDATION_ERROR';
export const SUBMIT_ATTEMPT_WITH_VALIDATION_ERRORS = 'SUBMIT_ATTEMPT_WITH_VALIDATION_ERRORS';
export const SUBMIT_ATTEMPT_WITH_SUBMISSION_VALIDATION_ERRORS = 'SUBMIT_ATTEMPT_WITH_SUBMISSION_VALIDATION_ERRORS';

// ReCaptcha
export const RECAPTCHA_RENDER_ERROR = 'RECAPTCHA_RENDER_ERROR';
export const RECAPTCHA_EXECUTION_TIMEOUT = 'RECAPTCHA_EXECUTION_TIMEOUT';

// Feature Control
export const FEATURE_CONTROL_FETCH_ERROR = 'FEATURE_CONTROL_FETCH_ERROR';

//form shortening
export const FORM_SHORTENING_FETCH_ERROR = 'FORM_SHORTENING_FETCH_ERROR';

// known properties
export const KNOWN_PROPERTIES_FETCH_ERROR = 'KNOWN_PROPERTIES_FETCH_ERROR';

// Virality
export const VIRALITY_INJECT_ERROR = 'VIRALITY_INJECT_ERROR';

//FrameEmbed
export const FORM_FRAME_RENDER_ERROR = 'FORM_FRAME_RENDER_ERROR';

// email
export const EMAIL_CHECK_FAILURE = 'EMAIL_CHECK_FAILURE';
export const EMAIL_RESUBSCRIBE_FAILURE = 'EMAIL_RESUBSCRIBE_FAILURE';

// Global events
export const GLOBAL_EVENTS_ERROR = 'GLOBAL_EVENTS_ERROR';